import axios from 'axios';

export const httpClientPesquisaSatisfacao = axios.create({
  baseURL: process.env.REACT_APP_API_PESQUISA_SATISFACAO,
});
